<div class="p-fluid p-grid">
  <div class="p-md-3 p-sm-12">
    <p-card header="Filtros" (keyup)="onEnterPesquisar($event)">
      <div class="p-fluid">
        <div class="p-field">
          <label for="topico">Tópico:</label>
          <p-dropdown placeholder="Favor selecionar o Tópico desejado" [options]="topicoItens"
            [(ngModel)]="ds.restricoes.atributo('topico').valor" filter="true">
          </p-dropdown>
        </div>
        <div class="p-grid">
          <m-restricao-entidade label="Situação" [restricao]="ds.restricoes.atributo('situacao')"
            [itens]="mensagemControleSituacaoItens" itemId="value" itemLabel="label">
          </m-restricao-entidade>
          <m-restricao-number label="Partição" [restricao]="ds.restricoes.atributo('particao')"></m-restricao-number>
          <m-restricao-string label="Conteúdo" [restricao]="ds.restricoes.atributo('conteudo')"></m-restricao-string>
          <m-restricao-temporal label="Auditoria data de inserção" [restricao]="ds.restricoes.atributo('auditoriaDataInsercao')"></m-restricao-temporal>
          <m-restricao-string label="Mensagem de erro" [restricao]="ds.restricoes.atributo('mensagemErro')"></m-restricao-string>
        </div>
      </div>
      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-col">
            <button pButton label="Pesquisar" (click)="pesquisar()"></button>
          </div>
          <div class="p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-md-9 p-sm-12">
    <p-card header="Mensagens">
      <p-table [value]="ds.mensagens"
        [sortField]="ds.sortField"
        [sortOrder]="ds.sortOrder"
        responsive="true" dataKey="mensagem.id" expandableRows="true" [scrollable]="true"
        scrollHeight="500px" emptyMessage="Nenhuma mensagem executada">

        <ng-template pTemplate="header">
          <tr>
            <th class="col-toggler"></th>
            <th class="col-mensagem" pSortableColumn="id">Mensagem <p-sortIcon field="id"></p-sortIcon></th>
            <th class="col-processamento">Processamento</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-mp let-expanded="expanded">
          <tr *ngIf="mp !== undefined" style="height: 65px">
            <td class="col-toggler">
              <a href="#" [pRowToggler]="mp">
                <em [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></em>
              </a>
            </td>
            <td class="col-mensagem">
              <div>{{mp.mensagem.id}}</div>
              <span class="label label-info margem-direita">
                Partição: {{mp.mensagem.particao}}
              </span>
            </td>
            <td class="col-processamento" style="text-align: center;">
              <span *ngIf="mp.situacao === 'PENDENTE'" class="pi pi-hourglass"></span>
              <span *ngIf="mp.situacao === 'EM_EXECUCAO'" class="pi pi-spin pi-spinner"></span>
              <span *ngIf="mp.situacao === 'EXECUTADO'">
                <span *ngIf="mp.resultado === 'PROCESSADO'" style="color: green">Processada</span>
                <span *ngIf="mp.resultado === 'IGNORADO'" style="color: darkgoldenrod">Ignorado</span>
                <span *ngIf="mp.resultado === 'NAO_ENCONTRADA'" style="color: darkgoldenrod">Não encontrada</span>
                <span *ngIf="mp.resultado === 'FALHA'" style="color: red">Falha</span>
              </span>
            </td>
          </tr>
          <tr *ngIf="mp === undefined" style="height: 65px">
            <td class="col-toggler"><div class="carregando-tabela"></div></td>
            <td class="col-mensagem"><div class="carregando-tabela"></div></td>
            <td class="col-processamento"><div class="carregando-tabela"></div></td>
          </tr>
        </ng-template>

        <ng-template let-mp pTemplate="rowexpansion">
          <tr>
            <td colspan="3">
              <div class="p-grid p-fluid">
                <div class="p-col-12 text-left m-l-10">
                  <h4>Conteúdo:</h4>
                  <textarea readonly rows="10" style="width: 100%">{{toJson(mp.mensagem.conteudo) | json}}</textarea>
                  <h4 [style.color]="getTipoSituacaoCor(mp.mensagem.situacao)">{{getTipoSituacaoDescricao(mp.mensagem.situacao)}}</h4>
                  <div *ngIf="mp.mensagem.situacao !== 'NAO_PROCESSADA'">
                    <strong>Data últ. tentativa::</strong> {{mp.mensagem.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss' }}<br />
                    <strong>Data inserção:</strong> {{mp.mensagem.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}<br />
                    <strong>Mensagem de erro:</strong> {{mp.mensagem.mensagemErro}}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="footer">
          <tr>
            <td colspan="3" style="text-align: right">
              Total~: {{total | number: '': 'pt-BR'}} - Carregadas: {{carregadas | number: '': 'pt-BR'}} - Processadas:
              {{processadas | number: '': 'pt-BR'}} - Falhas: {{falhas | number: '': 'pt-BR'}}
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-lg-6">
            <button pButton label="Iniciar" icon="pi pi-play" (click)="iniciarExecucao()" [disabled]="executando"
              class="p-button-success"></button>
          </div>
          <div class="p-col-12 p-lg-6">
            <button pButton label="Parar" icon="pi pi-pause" (click)="pararExecucao()"
              [disabled]="!executando"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>
</div>
